export var ShareSocialNetwork;
(function (ShareSocialNetwork) {
    ShareSocialNetwork["Telegram"] = "Telegram";
    ShareSocialNetwork["Facebook"] = "Facebook";
    ShareSocialNetwork["Twitter"] = "Twitter";
    ShareSocialNetwork["VK"] = "VK";
})(ShareSocialNetwork || (ShareSocialNetwork = {}));
export var LayoutDirection;
(function (LayoutDirection) {
    LayoutDirection["Row"] = "row";
    LayoutDirection["Column"] = "column";
})(LayoutDirection || (LayoutDirection = {}));
